// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-up-row';

export const Component = () => (
  <path d='m16.619 10.01-3.88-4.31v13.937h-.958V5.7l-3.88 4.31-.766-.67 4.454-4.933v-.048l.335-.287.288-.335h.096l.287.335.335.287v.048l4.454 4.933-.766.67ZM4.406 23.563h15.709a3.573 3.573 0 0 0 2.394-1.054 3.576 3.576 0 0 0 1.054-2.394v-7.376H15.71v-.958h7.854V4.405a3.573 3.573 0 0 0-1.054-2.394A3.576 3.576 0 0 0 20.115.957H4.406a3.573 3.573 0 0 0-2.394 1.054A3.576 3.576 0 0 0 .958 4.405v7.376h7.854v.958H.958v7.376a3.573 3.573 0 0 0 1.054 2.394 3.576 3.576 0 0 0 2.394 1.054Zm20.115-3.448c0 1.198-.431 2.25-1.293 3.113a4.267 4.267 0 0 1-3.113 1.293H4.406c-1.197 0-2.25-.431-3.113-1.293A4.267 4.267 0 0 1 0 20.115V4.406c0-1.197.431-2.25 1.293-3.113A4.267 4.267 0 0 1 4.406 0h15.709c1.198 0 2.25.431 3.113 1.293a4.267 4.267 0 0 1 1.293 3.113v15.709Z' />
);

export const viewBox = '0 0 25 25';
